module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_8019.4675f94d.png";